import AzanBox from '../calendar/AzanBox';
import CalendarBox from '../calendar/CalendarBox';
import IEvent, {getEventsOf} from '../calendar/IEvent';
import Ads from './Ads';
import LiveList from './LiveList';
import NewsChannel from './NewsChannel';
import TopServices from './TopServices';
import RadioBox from '../radio/RadioBox';
import VersionsHistory from '../notifications/VersionsHistory';

export default function Home() {
	var d = new Date();
	const dayEvent: IEvent[] = [];
	while (true) {
		dayEvent.push(...getEventsOf(d));
		if (dayEvent.length > 1) {
			break;
		}
		d.setDate(d.getDate() + 1);
	}
	return (
		<div className="flex flex-col space-y-4">
			<VersionsHistory/>
			<CalendarBox/>
			{/*<Ads/>*/}
			<LiveList/>
			<AzanBox/>
			<TopServices/>
			<RadioBox/>
			<NewsChannel/>
		</div>
	);
}
